import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    roles: []
};
function roleResource(data) {
    return {
        id: data.id,
        name: data.name
    };
}
export var RolesReducer = createSlice({
    name: 'roles',
    initialState: initialState,
    reducers: {
        setRoles: function setRoles(state, payloadAction) {
            var data = [];
            payloadAction.payload.forEach(function (item) {
                data[item.id] = roleResource(item);
            });
            state.roles = data;
        }
    }
});
var setRoles = RolesReducer.actions.setRoles;
export { setRoles };
export default RolesReducer.reducer;
